export const FETCH_DETAILS_START = "homepage/FETCH_DETAILS_START";
export const FETCH_DETAILS_COMPLETED = "homepage/FETCH_DETAILS_COMPLETED";
export const FETCH_DETAILS_FAILED = "homepage/FETCH_DETAILS_FAILED";

export const TOGGLE_LIKE_COMPLETED = "homepage/TOGGLE_LIKE_COMPLETED";
export const UPDATE_MEDIA_ITEM = "homepage/UPDATE_MEDIA_ITEM";

export const TOGGLE_WATCHED_COMPLETED = "homepage/TOGGLE_WATCHED_COMPLETED";
export const ON_CHANGE_FAVORITE_ITEM_COMPLETED = "homepage/ON_CHANGE_FAVORITE_ITEM_COMPLETED";
